import {Action, ActionReducer, ActionReducerMap, MetaReducer} from '@ngrx/store';
import {localStorageSync} from 'ngrx-store-localstorage';
import {userReducer, UserState} from './user';
import {cachedIdbConnection} from '../indexeddb/cached-idb-connection';
import {quoteReducer, QuoteState} from './quote';
import {standaloneReducer, StandaloneState} from './standalone/standalone.reducers';
import {translationReducer, TranslationState} from './translation';

export interface CoreState {
    user: UserState;
    quote: QuoteState;
    standalone: StandaloneState;
    translation: TranslationState;
}

export const reducers: ActionReducerMap<CoreState> = {
    user: userReducer,
    quote: quoteReducer,
    standalone: standaloneReducer,
    translation: translationReducer
};

export function localStorageSyncReducer(reducer: ActionReducer<CoreState>): ActionReducer<CoreState> {
    return localStorageSync({
        keys: ['user', 'standalone', 'translation'],
        rehydrate: true,
    })(reducer);
}

export const quoteMetaReducers: Array<MetaReducer<CoreState, Action>> = [localStorageSyncReducer, indexedDbSyncReducer];


const DB_NAME = 'ngrx-indexeddb';
const STORE_NAME = 'core';
const STATE_KEY = 'quote';
const getDb = cachedIdbConnection(DB_NAME, [STORE_NAME]);

export function indexedDbSyncReducer<State extends { [key: string]: any }>(
    reducer: ActionReducer<State>
): ActionReducer<State> {
    let initialized = false;
    return function(state: State | undefined, action: Action): State {
        const nextState = reducer(state, action);
        if (initialized && nextState?.[STATE_KEY]) {
            saveToIndexedDb(STATE_KEY, nextState[STATE_KEY]);
        }
        if (!initialized && typeof window !== 'undefined') {
            initialized = true;
        }
        return nextState;
    };
}

async function saveToIndexedDb(key: string, value: any) {
    const db = await getDb();
    await db.put(STORE_NAME, value, key);
}

export async function loadFromIndexedDb(key: string): Promise<any> {
    const db = await getDb();
    return db.get(STORE_NAME, key);
}
